export default __webpack_public_path__ + "static/media/04-image.210b9f5f.jpg";